import { SelectDropdown } from '@makyoapp/makyo-ui'

import { useAppBrandKitContext } from '@/context/AppBrandKitContext'
import { useBuilderColorSchemeV2 } from '@/hooks/__project__/useBuilderColorSchemeV2'
import { getThemeHexColorScheme } from '@/shared/brand-kit'

interface ColorSchemeFieldSettingProps {
  id: string
  settingId: string
  value: any
  onChange(value: any): void
}

/**
 * @todo fix the color not showing
 */
const ColorSchemeFieldSetting = ({ settingId, value, onChange }: ColorSchemeFieldSettingProps) => {
  const { themes } = useAppBrandKitContext()

  const [colorScheme] = useBuilderColorSchemeV2()

  const renderOption = (opt: any) => {
    const colors =
      opt && themes[Number(opt)]?.theme
        ? Object.entries(getThemeHexColorScheme(themes[Number(opt)].theme, colorScheme.current))
        : []
    return opt ? (
      <div className='flex w-full'>
        {colors.map(([k, c]) => {
          return <div key={k} className='w-4 h-4 shrink-0 basis-1/4' style={{ background: c }} />
        })}
      </div>
    ) : null
  }

  const optionLabel = (opt: any) => themes[Number(opt)]?.name

  const options = Array.from(Array(themes.length), (_, i) => {
    return `${i}`
  })

  return (
    <SelectDropdown
      id={settingId}
      value={value}
      onChange={onChange}
      optionLabel={optionLabel}
      renderOption={renderOption}
      options={options}
    />
  )
}

export default ColorSchemeFieldSetting
